module.exports = __webpack_public_path__ + "static/media/Operations manager - Sasidharan V.P.2204db55.jpg";